import React from 'react'
import styled from '@emotion/styled'
import InlineSVG from 'svg-inline-react'

import { useSelector, useDispatch } from 'react-redux'
import * as Selectors from 'state/selectors'
import * as Actions from 'state/actions'


const ItemWrapper = styled.div`
  &:hover{
    background-color: #90A1B0;
    color: #FFFFFF;
  }
`


const OrgWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  max-width: 480px;
  margin-top: 10px;
  margin-bottom: 10px;
  
  cursor: pointer;
  transition: opacity .3s ease;
`
const ItemTitle = styled.div`
  font-size: 16px;
`
const InboxesWrapper = styled.div`
  overflow-y: auto;
  max-height: 100%;
  margin-top: 10px;
  padding-bottom: 100px;
`


const OrgMenu = () => {
  const active = useSelector(Selectors.getActiveOrganisationId)
  const organisations = useSelector(Selectors.getOrganisations)
    .filter((o) => o.id !== active)
  const dispatch = useDispatch()
  const selectOrg = (id) => dispatch(Actions.setOrganisation(id))


  return (
    <InboxesWrapper>
      {
        organisations.map((o, i) => (
          <ItemWrapper key={i} onClick={() => selectOrg(o.id)}>
            <OrgWrapper>
              <ItemTitle>{ o.name }</ItemTitle>
            </OrgWrapper>
          </ItemWrapper>
        ))
      }
    </InboxesWrapper>

  )
}

export default OrgMenu
